import { api } from '../lib/api'

export type ReferralResolveResponse = {
  valid: boolean
  code: string
  referrer_user_id: number
  referrer_handle: string
  referrer_display_name: string
}

export async function resolveReferralCode(code: string): Promise<ReferralResolveResponse> {
  const normalized = String(code || '').trim()
  const { data } = await api.get<ReferralResolveResponse>(`/api/referrals/resolve/${encodeURIComponent(normalized)}/`)
  return data
}

